import '../../../../vendor/angular-ui-bootstrap/src/buttons/buttons.js';

export const uiBootstrapButtonsModule = 'ui.bootstrap.buttons';
